define(["require", "exports", "jquery", "knockout", "../../utils/kendoUtils", "../../models/UserContext", "../todos/todoActions"], function (require, exports, $, ko, KendoUtils, UserContext, TodoActions) {
    "use strict";
    var CustomerTasks = /** @class */ (function () {
        function CustomerTasks(customerId, lookupLists, initCallback) {
            this.userCanViewTodo = ko.observable(UserContext.hasAccess("Admin,ToDo.View,ToDo.Edit,ToDo.Delete"));
            this.userCanEditTodo = ko.observable(UserContext.hasAccess("Admin,ToDo.Edit,ToDo.Delete"));
            this.userCanDeleteTodo = ko.observable(UserContext.hasAccess("Admin,ToDo.Delete"));
            this.todoActions = new TodoActions();
            this.customerId = ko.observable(0);
            var self = this;
            self.customerId(customerId);
            self.lookupLists = lookupLists;
            self.customerTasksGridStructure = self.lookupLists.GridStructures.TodosStructure;
            if (this.userCanViewTodo()) {
                self.todoActions.saveCallback = function () {
                    var _a;
                    (_a = self.customerTasksTable) === null || _a === void 0 ? void 0 : _a.refresh();
                };
                self.todoActions.deleteCallback = function () {
                    var _a;
                    (_a = self.customerTasksTable) === null || _a === void 0 ? void 0 : _a.refresh();
                };
                if (this.userCanViewTodo()) {
                    self.initExportDataSource();
                    if (initCallback) {
                        initCallback(self);
                    }
                }
            }
        }
        CustomerTasks.prototype.initGrid = function () {
            if (this.userCanViewTodo()) {
                this.initCustomerTodoList();
            }
        };
        CustomerTasks.prototype.initExportDataSource = function () {
            var self = this;
            self.customerTasksDataSourceOptions = {
                transport: {
                    read: {
                        url: "/ToDo/GetCustomerTodos",
                        type: "POST",
                        data: function () {
                            return {
                                customerId: self.customerId()
                            };
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.customerTasksGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerTasksDataSource = new kendo.data.DataSource(self.customerTasksDataSourceOptions);
        };
        CustomerTasks.prototype.initCustomerTodoList = function () {
            var self = this;
            var columns = self.customerTasksGridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditTodo()) {
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\"><i class=\"fa fa-edit \"></i></a>";
                    }
                    if (self.userCanDeleteTodo()) {
                        html += "&nbsp;<button class=\"btn btn-sm btn-danger btn-remove\"><i class=\"fa fa-trash-o\"></i></button>";
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.customerTasksTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ToDo/GetCustomerTodos",
                            type: "POST",
                            data: function () {
                                return {
                                    customerId: self.customerId()
                                };
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.customerTasksGridStructure.model
                    }
                },
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    scrollable: true,
                    height: 500,
                },
                enableExport: {
                    entityName: "Todo",
                    title: "Todo",
                    enablePdf: false
                },
                gridId: "tblTodos",
                showPagerOnTop: false,
                controller: self
            };
            self.customerTasksTable.initGrid(gridOptions);
            $("#tblTodos tbody").on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.todoActions.editTodo(dataItem.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.todoActions.deleteTodoConfirm(dataItem.Id);
                event.preventDefault();
            });
        };
        CustomerTasks.prototype.addNewTodo = function () {
            var self = this;
            self.todoActions.editTodo(null, self.customerId());
        };
        return CustomerTasks;
    }());
    return CustomerTasks;
});
//# sourceMappingURL=customerTasks.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerTasks.js
// module id = 202
// module chunks = 2